import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/AgentPortalSoftware`,
  scopes: ExtHubRequest,
});
const Broker = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/ssiBroker`,
  scopes: ExtHubRequest,
});

Broker.createEntities([{ name: 'generateSSILink' }]);

const GenerateSSILink = (body) => Broker.endpoints.generateSSILink.post(body);

api.createEntities([
  { name: 'GetSoftware' },
  { name: 'GetSoftwareListByProduct' },
  { name: 'GetListOfYears' },
  { name: 'OutputFileReturnName' },
  { name: 'GetAgencyList' },
  { name: 'GetEndDateList' },
  { name: 'GetAgentsForAgencyList' },
  { name: 'GetWeeklyAgentsReportDtl' },
  { name: 'GetCheckoutSituationId' },
  { name: 'PrintAllForms' },
  { name: 'SetOrderForm' },
  { name: 'GetOrderSituationForms' },
  { name: 'GetAgentsForAgencyMgrUse' },
  { name: 'InsertUpdateWAR_Dtl' },
  { name: 'GetCalculatorPlansByProduct' },
]);

//const GenerateSSILink = (body) => oldapi.endpoints.GenerateSSILink.post(body);
const GetSoftware = (showCategories) =>
  api.endpoints.GetSoftware.postMultipleQueryString([
    {
      queryParam: 'showCategories',
      queryVal: showCategories,
    },
  ]);
const GetSoftwareListByProduct = (body) => api.endpoints.GetSoftwareListByProduct.post(body);
//const GetSoftwareListAsync = (body) => api.endpoints.GetSoftwareList.post(body);
const GetSoftwareListByProductAsync = (body) => api.endpoints.GetSoftwareListByProduct.post(body);
const GetListOfYears = (body) => api.endpoints.GetListOfYears.post(body);
const OutputFileReturnName = (body) => api.endpoints.OutputFileReturnName.post(body);
const GetAgencyList = () => api.endpoints.GetAgencyList.post();
const GetEndDateList = (body) => api.endpoints.GetEndDateList.post(body);
const GetAgentsForAgencyList = (body) => api.endpoints.GetAgentsForAgencyList.post(body);
const GetWeeklyAgentsReportDtl = (body) => api.endpoints.GetWeeklyAgentsReportDtl.post(body);
const GetCheckoutSituationId = (body) => api.endpoints.GetCheckoutSituationId.post(body);
const PrintAllForms = (body) => api.endpoints.PrintAllForms.post(body);
const SetOrderForm = (body) => api.endpoints.SetOrderForm.post(body);
const GetOrderSituationForms = (body) => api.endpoints.GetOrderSituationForms.post(body);
const GetAgentsForAgencyMgrUse = (body) => api.endpoints.GetAgentsForAgencyMgrUse.post(body);
const InsertUpdateWAR_Dtl = (body) => api.endpoints.InsertUpdateWAR_Dtl.post(body);
const GetCalculatorPlansByProduct = (body) => api.endpoints.GetCalculatorPlansByProduct.post(body);

export {
  GenerateSSILink,
  GetSoftware,
  GetSoftwareListByProduct,
  GetSoftwareListByProductAsync,
  GetListOfYears,
  OutputFileReturnName,
  GetAgencyList,
  GetEndDateList,
  GetAgentsForAgencyList,
  GetWeeklyAgentsReportDtl,
  GetCheckoutSituationId,
  PrintAllForms,
  SetOrderForm,
  GetOrderSituationForms,
  GetAgentsForAgencyMgrUse,
  InsertUpdateWAR_Dtl,
  GetCalculatorPlansByProduct,
};
